export default __webpack_public_path__ + "1948cc349ce34987e916ae76d296021c.png";